import MensajeInvalidos from "@/components/MensajeInvalidos.vue";

const install = (app) => {
  //Registro de componentes
  app.component("MensajeInvalidos", MensajeInvalidos);
};
export default install;
